import {Component} from '@angular/core';
import {LanguageService} from './language.service';

/**
 * ヘッダーの言語メニュー (国旗ボタン → 日本語 / English)。ira-groupnet.app の languages と同じ見た目。
 */
@Component({
    standalone: false,
    selector: 'app-languages',
    template: `
        <div class="ap-languages" dropdown placement="bottom right" container="body">
            <button type="button" class="btn btn-link ap-languages-toggle" dropdownToggle [attr.aria-label]="'language' | transloco">
                <ng-container *ngTemplateOutlet="flag; context: {$implicit: current}"></ng-container>
            </button>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                <li *ngFor="let lang of language.langs" role="menuitem">
                    <a class="dropdown-item" href="javascript:void(0)" [class.active]="lang.id === language.active" (click)="language.setLang(lang.id)">
                        <ng-container *ngTemplateOutlet="flag; context: {$implicit: lang}"></ng-container>
                        <span class="ml-2">{{ lang.label }}</span>
                    </a>
                </li>
            </ul>
        </div>
        <ng-template #flag let-lang>
            <img class="ap-languages-flag" [src]="'assets/img/flags/' + lang.flag + '.svg'" [alt]="lang.label">
        </ng-template>
    `,
    styles: [`
        .ap-languages { display: inline-block; }
        .ap-languages-toggle { padding: 0 .5rem; line-height: 1; }
        .ap-languages-flag { width: 24px; height: 16px; object-fit: cover; box-shadow: 0 0 0 1px rgba(0, 0, 0, .1); border-radius: 2px; vertical-align: middle; }
    `],
})
export class LanguagesComponent {
    constructor(public language: LanguageService) {
    }

    get current() {
        return this.language.langs.find((l) => l.id === this.language.active) || this.language.langs[0];
    }
}
